import { createStore } from 'vuex'
import Axios from 'axios'

export default createStore({
  state: {
    page: null,
    info: null,
    unsaved: [],
    isPageReady: true,

    admin: {
      edit_menu: {
        show: false,
        top: 0,
        left: 0,
        this_ctx: null,
      },
      edit_this: null,
      type: null,
      is_menu_hidden: false,
    },

    data: {
      buyers: null,
      production: null,
      about: null,
      news: null,
    }
  },
  mutations: {
    setPage(state, {page}) {
      state.page = page;
    },
    setInfo(state, {info}) {
      state.info = info;
    },
    pushUnsaved(state, {page}) {
      if (state.unsaved.indexOf(page) === -1) {
        state.unsaved.push(page);
      }
    },
    spliceUnsaved(state, {page}) {
      const index = state.unsaved.indexOf(page);
      if (index !== -1) {
        state.unsaved.splice(index, 1);
      } 
    },
    setIsPageReady(state, {is}) {
      state.isPageReady = is;
    },
    setAdmin(state, {property, value}) {
      state.admin[property] = value;
    },
    setIsMenuHidden(state, {value}) {
      state.is_menu_hidden = value;
    },
    setBuyers(state, {value}) {
      state.data.buyers = value;
    },
    setProduction(state, {value}) {
      state.data.production = value;
    },
    setNews(state, {value}) {
      state.data.news = value;
    },
    setAbout(state, {value}) {
      state.data.about = value;
    },
  },
  actions: {
    changeBuyers(ctx, {value}) {
      ctx.commit('setBuyers', {value});
    },
    changeProduction(ctx, {value}) {
      ctx.commit('setProduction', {value});
    },
    changeNews(ctx, {value}) {
      ctx.commit('setNews', {value});
    },
    changeAbout(ctx, {value}) {
      ctx.commit('setAbout', {value});
    },
    changeAdmin(ctx, {property, value}) {
      ctx.commit('setAdmin', {property, value})
    },
    changeIsMenuHidden(ctx, {value}) {
      ctx.commit('setIsMenuHidden', {value});
    },
    emit(ctx, {this_ctx, emit_text, emit_value = {}}) {
      const emit = function() {
        this.$emit(emit_text, emit_value);
      }.bind(this_ctx);
    },
    // initYMaps() {
    //   ymaps.ready(()=>{
    //       var myMap = new ymaps.Map("map", {
    //           center: [56.773943, 62.037351],
    //           zoom: 17,
    //           controls: ['zoomControl'],
    //       });
    //       var placemark = new ymaps.Placemark([56.773643, 62.039351], {
    //           iconContent: 'ООО "Огнеупорные Решения"'
    //       }, {
    //           preset: "islands#yellowStretchyIcon",
    //       });
    //       myMap.geoObjects.add(placemark);
    //   });
    // },
    changeIsPageReady(ctx, {is}) {
      ctx.commit('setIsPageReady', {is})
    },
    addUnsavedPage(ctx, {page}) {
      ctx.commit('pushUnsaved', {page});
    },
    removeUnsavedPage(ctx, {page}) {
      ctx.commit('spliceUnsaved', {page});
    },
    changePage(ctx, {page}) {
      window.history.replaceState(page, page, page);
      ctx.commit('setPage', {page});
    },
    changeInfo(ctx, {data}) {
      ctx.commit('setInfo', {info: data})
    },
    setToDB(ctx, payload) {
      const table = payload.table;
      const content = payload.content;
      const deleted = payload.deleted ? payload.deleted : [];
      Axios.post('/api/setToDB', {
        table, content, deleted,
      }) 
      
      .then(({data})=>{
        if(data === 'OK') {
          alert('Успешно сохранено в таблицу "' + payload.table + '"');
        }
      })
    },
    convertText({dispatch}, {text, container}) {
      let time = (new Date()).getTime();
      let innerText = '';
      for (let char_i = 0; char_i < text.length; char_i++) {
          const char = text[char_i];
          if (char === '{') {
              innerText ? 
              dispatch('_appendElementWithCurrentInnerText', {container, innerText}) : null;
              innerText = ' ';
          } else if (char === '}') {
              dispatch('_appendCustomizedElementWithCurrentInnerText', {container, innerText});
              innerText = ' ';
          } else if (char === '^') {
              innerText ? 
              dispatch('_appendElementWithCurrentInnerText', {container, innerText}) : null;
              innerText = ' ';
              dispatch('_appendBrTag', {container});
          } else if (char_i === text.length - 1) {
              innerText += char;
              dispatch('_appendElementWithCurrentInnerText', {container, innerText});
          } else {
              innerText += char;
          }
      }
    },
    _appendElementWithCurrentInnerText(ctx, {container, innerText}) {
        const p = document.createElement('p');
        p.innerText = innerText;
        p.style.display = 'inline';
        container.appendChild(p);
    },
    _appendCustomizedElementWithCurrentInnerText(ctx, {container, innerText}) {
        const p = document.createElement('p');
        p.innerText = innerText;
        p.style.display = 'inline';
        p.style.color = '#EBB932';
        container.appendChild(p);
    },
    _appendBrTag(ctx, {container}) {
        const br = document.createElement('br');
        container.appendChild(br);
    }
  },
  getters: {
    getInfo(state) {
      return state.info;
    },
    getPage(state) {
      return state.page;
    },
    getUnsaved(state) {
      return state.unsaved;
    },
    getIsPageReady(state) {
      return state.isPageReady;
    },
    getAdmin: state => property => {
      return state.admin[property];
    },
    getAdminEditThis(state) {
      return state.admin.edit_this;
    },
    getIsMenuHidden(state) {
      return state.is_menu_hidden;
    },
    getBuyers(state) {
      return state.data.buyers;
    },
    getProduction(state) {
      return state.data.production;
    },
    getAbout(state) {
      return state.data.about;
    },
    getNews(state) {
      return state.data.news;
    }
  },
  modules: {
  }
})
